import {IRewardHorizontalV2Props} from "@housebets/housebets-x-package";
import {IVipReload} from "@housebets/housebets-x-package/lib/components/feature/rewards/VipReload/types";
import {addDays} from "date-fns";
import {getCurrencyIcon} from "app/utils/help";

export const currencyListOpt = [
    {
        id: "USDT",
        name: "Tether (USDT)",
        icon: "/img/wallet/crypto/USDT.png",
    },
    {
        id: "ETH",
        name: "Etherium (ETH)",
        icon: "/img/wallet/crypto/ETH.png",
    },
    {
        id: "APL",
        name: "Apollo (APL)",
        icon: "/img/wallet/crypto/APL.png",
    },
    {
        id: "QKC",
        name: "Quarkchein (QKC)",
        icon: "/img/wallet/crypto/QKC.png",
    },
    {
        id: "BTC",
        name: "Bitcoin (BTC)",
        icon: "/img/wallet/crypto/BTC.png",
    },
    {
        id: "NXT",
        name: "Nxt (NXT)",
        icon: "/img/wallet/crypto/NXT.png",
    },
];

export const vipClaimData: IVipReload = {
    id: "1",
    title: "Choose the currency you would like to be paid out in:",
    image: "/img/rewards/reward/2-2.png",
    selectedCurrency: [1],
    list: currencyListOpt,
    total: {
        amount: "95.2",
        currency: "1",
        currencyIcon: getCurrencyIcon(1),
    },
    claims: {
        currentLevel: 4,
        maxLevels: 12,
        list: [
            {
                level: 1,
                claimed: true,
                activeAt: addDays(new Date(), -10),
                amount: "95.2",
            },
            {
                level: 2,
                claimed: false,
                activeAt: addDays(new Date(), -10),
                amount: "95.2",
            },
            {
                level: 3,
                claimed: true,
                activeAt: addDays(new Date(), -10),
                amount: "95.2",
            },
            {
                level: 4,
                claimed: false,
                activeAt: addDays(new Date(), 0),
                amount: "95.2",
            },
            {
                level: 5,
                claimed: false,
                activeAt: addDays(new Date(), 1),
                amount: "95.2",
            },
            {
                level: 6,
                claimed: false,
                activeAt: addDays(new Date(), 1),
                amount: "95.2",
            },
            {
                level: 7,
                claimed: false,
                activeAt: addDays(new Date(), 1),
                amount: "95.2",
            },
            {
                level: 8,
                claimed: false,
                activeAt: addDays(new Date(), 1),
                amount: "95.2",
            },
            {
                level: 9,
                claimed: false,
                activeAt: addDays(new Date(), 1),
                amount: "95.2",
            },
            {
                level: 10,
                claimed: false,
                activeAt: addDays(new Date(), 1),
                amount: "95.2",
            },
            {
                level: 11,
                claimed: false,
                activeAt: addDays(new Date(), 1),
                amount: "95.2",
            },
            {
                level: 12,
                claimed: false,
                activeAt: addDays(new Date(), 1),
                amount: "95.2",
            },
        ],
        nextClaimAt: addDays(new Date(), 0),
    },
};

export const rewardsData: IRewardHorizontalV2Props[] = [
    {
        id: "1",
        text: "",
        name: "Instant Rakeback",
        claimed: false,
        enableAt: "",
        isAuth: true,
        image: "instant_rakeback",
        type: "pending",
        actionType: "instant_rakeback",
    },
    {
        text: "6 claims left",
        name: "Weekly reload",
        claimed: false,
        enableAt: "",
        isAuth: true,
        image: "week_reload",
        type: "remaining",
        actionType: "weekly_reload",
        id: "2",
    },
    {
        text: "6 claims left",
        name: "Monthly reload",
        claimed: false,
        enableAt: "",
        buttonText: "Claim",
        isAuth: true,
        image: "month_reload",
        type: "remaining",
        actionType: "monthly_reload",
        id: "3",
    },
    {
        text: "6 claims left",
        name: "VIP reload",
        claimed: false,
        enableAt: addDays(new Date(), 0),
        isAuth: true,
        image: "vip_reload",
        type: "remaining",
        actionType: "vip_reload",
        id: "1",
        details: {
            ...vipClaimData,
            id: 1,
        },
    },
    {
        text: "23 hours left",
        name: "VIP reload",
        claimed: false,
        enableAt: addDays(new Date(), 3),
        isAuth: true,
        image: "vip_reload",
        type: "remaining",
        actionType: "vip_reload",
        id: "1",
        details: {
            ...vipClaimData,
            id: 1,
        },
    },
];
